var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-fields-edit--wrap"},[(_vm.item.editing && !_vm.definition.inline_edits)?_c('v-btn',{staticClass:"form-fields-edit",attrs:{"color":"appMain"},on:{"click":function($event){$event.preventDefault();return _vm.doneEditing(_vm.item)}}},[_vm._v(" Done Editing ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }